export const nextYear = (new Date().getFullYear() + 1).toString();
